<script setup lang="ts">
import fooFromUtilsPackage from '@inner/utils';

fooFromUtilsPackage()

</script>

<template>
  <router-view></router-view>
</template>

<style scoped>
</style>
